import TicketsManagement from "./TicketDisplay";
import { ViewTicket } from "./TicketTable";

const allticketRoutes = [
  {
    path: "ticket",
    component: <TicketsManagement />,
  },
];

const TicketsManagementpage = {
  path: "ticket",
  component: <TicketsManagement />,
};

const ViewButton = {
  path: "ticket/:id/",
  component: <ViewTicket />,
};

export default allticketRoutes;

export { TicketsManagementpage, ViewButton };
